import React from "react";
import { useDispatch } from "react-redux";
import { reduxForm, InjectedFormProps } from "redux-form";
import { useNavigate } from "react-router";

import { SubmitBtn } from "capitalrx-components";

import { uploadTestClaimBatchActions } from "@/App/actions/";
import ExcelFileUpload from "@/App/components/ExcelFileUpload";
import TestClaimLayout from "@/App/layouts/TestClaim";
import { TransmissionTypes } from "@/types";
import ResultTable from "./ResultTable";

const formName = "TestClaimBatchUploadForm";

const TestClaimBatchUpload: React.FC<InjectedFormProps> = (props: InjectedFormProps) => {
  const { handleSubmit, pristine, submitting } = props;
  const dispatch = useDispatch();
  const { uploadTestClaimBatch } = uploadTestClaimBatchActions;
  const navigate = useNavigate();

  const handleFormSubmit = (data: TransmissionTypes.TestClaimBatchUploadFile): void => {
    dispatch(uploadTestClaimBatch(data, formName, navigate));
  };

  return (
    <TestClaimLayout selected="rightToggle">
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <ExcelFileUpload formName={formName} pristine={pristine} />
        <div className="row caprx-h-center-text">
          <SubmitBtn fullWidth={false} disabled={pristine} type="submit" submitting={submitting}>
            Test Adjudication
          </SubmitBtn>
        </div>
      </form>

      <ResultTable />
    </TestClaimLayout>
  );
};

export default reduxForm({ form: formName })(TestClaimBatchUpload);
